import React, { Component, Fragment } from 'react';
import { format } from 'date-fns';
import I18n from '~/utils/translations';

export default class AddToGoogleCalendarButton extends Component {
  render() {
    return (
      <Fragment>
        <div className="add-to-calendar">
          <a
            className="add-to-calendar__button add-to-calendar__button--google"
            href={this.generateGoogleCalendarLink()}
            target="_blank"
          >
            + {I18n.t('viewings.add_to_google_calendar')}
          </a>
        </div>
      </Fragment>
    );
  }

  formatDate(date) {
    return format(date, "yyyyMMdd'T'HHmmss");
  }

  generateGoogleCalendarLink() {
    // https://github.com/InteractionDesignFoundation/add-event-to-calendar-docs/blob/master/services/google.md

    const formattedStart = this.formatDate(this.startTime.getTime() + this.startTime.getTimezoneOffset() * 60000);
    const formattedEnd = this.formatDate(this.endTime.getTime() + this.endTime.getTimezoneOffset() * 60000);

    const baseUrl = 'https://calendar.google.com/calendar/render';
    const action = 'TEMPLATE';
    const text = I18n.t('viewings.calendar_title', { headline: this.formattedHeadline });
    const details = this.detailsPath;
    const dates = formattedStart + 'Z/' + formattedEnd + 'Z';
    const location = this.props.location;

    return `${baseUrl}?action=${action}&text=${text}&details=${details}&dates=${dates}&location=${location}`;
  }

  get formattedHeadline() {
    return this.props.headline.replace('#', '');
  }

  get detailsPath() {
    return window.location.href.replace('#booked-viewing', '');
  }

  get startTime() {
    return new Date(this.props.viewingStart);
  }

  get endTime() {
    if (this.props.viewingEnd) {
      return new Date(this.props.viewingEnd);
    } else {
      return new Date(this.startTime.getTime() + 30 * 60000);
    }
  }
}
